import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[--bg-primary] border-t border-[--border-primary]">
      <div className="w-full px-4">
        <div className="min-h-12 flex flex-wrap justify-between items-center gap-4 py-2">
          <p className="text-sm text-[--text-disabled] ml-16">
            <span className="hidden sm:inline">© {currentYear} Scholar42 by InfiniPouch. All rights reserved.</span>
            <span className="inline sm:hidden">© InfiniPouch</span>
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/about"
              className="text-sm text-[--text-secondary] hover:text-[--text-primary] transition-colors"
            >
              About
            </Link>
            <Link
              to="/terms"
              className="text-sm text-[--text-secondary] hover:text-[--text-primary] transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/contact"
              className="text-sm text-[--text-secondary] hover:text-[--text-primary] transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}